import { SelectedFiltersT } from './types';

export const defaultFilters: SelectedFiltersT = {
  page: 0,
  size: 10,
  status: [],
  type: [],
};

export const contextDefaultValues = {
  selectedFilters: defaultFilters,
  initialFilters: defaultFilters,
  lotTypes: [],
  lotStatuses: [],
  regions: [],
  categories: [],
  employees: undefined,
  companies: undefined,
  isLoadingCategories: undefined,
  isLoadingCompany: undefined,
  applyFilters: () => undefined,
  setField: () => undefined,
  debouncedSearchCategory: () => undefined,
  debouncedSearchCompany: () => undefined,
  resetFilters: () => undefined,
  applyDirect: () => undefined,
};
